import Clients from "./clients";
import { useContext, useEffect } from "react";
import AddClient from "./add-client";
import { ClientDetailsStyled } from "./client-details.styles";
import { UserAppointmentContext } from "../../../context/user-appointment-context";
import useFetchUserDetails from "../../../../../hooks/useFetchUserDetails";
import Loader from "../../../../../components/loader/loader";

const ClientDetails = () => {
  const {
    state: { isUserExisted, user, updateUserMeta },
  } = useContext(UserAppointmentContext);

  const {
    emailUsers,
    phoneUsers,
    loading,
    fetchDetailsByEmail,
    fetchDetailsByPhone,
  } = useFetchUserDetails();

  useEffect(() => {
    if (user?.email) fetchDetailsByEmail(user?.email);
    if (user?.phone) fetchDetailsByPhone(user?.phone);
  }, [fetchDetailsByEmail, fetchDetailsByPhone, user?.email, user?.phone]);

  const showUI =
    !updateUserMeta &&
    isUserExisted &&
    (emailUsers?.length > 0 || phoneUsers?.length > 0);

  const showUpdateFormLoader = updateUserMeta && !user;
  const showLoader = loading || showUpdateFormLoader;

  return (
    <ClientDetailsStyled>
      {showLoader && <Loader absolute />}
      {!loading && !showUpdateFormLoader && showUI ? (
        <Clients />
      ) : (
        <AddClient />
      )}
    </ClientDetailsStyled>
  );
};

export default ClientDetails;
